import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AnchorButton from '@adsk/bim360-matrix-react-anchor-button';

import './_DropdownSelectMenuItem.scss';

/**
 * A selectable menu item component used with DropdownSelectMenu
 */
export default class DropdownSelectMenuItem extends Component {
  /**
   * constructor
   */
  constructor() {
    super();
    this._handleOnMenuItemClick = this._handleOnMenuItemClick.bind(this);
  }

  /**
   * onMenuItemClick
   */
  _handleOnMenuItemClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onClick(this.props.eventKey, this.props.label);
  }

  /**
   * render
   */
  render() {
    const { disabled, subtext, boldSelection, selected, prefix, label } = this.props;
    const anchorClasses = classNames('DropdownSelectMenuItem__item', {
      'with-subtext': subtext
    });
    const labelClasses = classNames('DropdownSelectMenuItem__label', {
      ['DropdownSelectMenuItem__label--selected']: boldSelection && selected
    });

    return (
      <li>
        <AnchorButton
          data-testid="DropdownSelectMenuItem__item"
          className={anchorClasses}
          onClick={this._handleOnMenuItemClick}
          disabled={disabled}
        >
          {prefix ? prefix() : null}
          <div className="DropdownSelectMenuItem__label-section">
            <span className={labelClasses}>{label}</span>
            {subtext ? <span className="DropdownSelectMenuItem__subtext">{subtext}</span> : null}
          </div>
          {selected && (
            <svg
              className="DropdownSelectMenuItem__icon"
              height="16px"
              width="16px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="-2 0 16 13"
            >
              <path
                d="M4.646 10.354l.432.43.338-.507 6-9-.832-.554-6 9 .77-.077-4-4-.708.708z"
                fill="currentColor"
              />
            </svg>
          )}
        </AnchorButton>
      </li>
    );
  }
}

DropdownSelectMenuItem.defaultProps = {
  selected: false,
  disabled: false,
  boldSelection: false
};

DropdownSelectMenuItem.propTypes = {
  /**
   * The event key of the item. Will be used when selecting occurs
   */
  eventKey: PropTypes.string.isRequired,
  /**
   * The displayed text of the item
   */
  label: PropTypes.string.isRequired,
  /**
   * Displayed text beneath the label
   */
  subtext: PropTypes.string,
  /**
   * Whether the item should be displayed as selected
   */
  selected: PropTypes.bool,
  /**
   * Whether the item should be disabled
   */
  disabled: PropTypes.bool,
  /**
   * Whether or not to make selection bold
   */
  boldSelection: PropTypes.bool,
  /**
   * A callback function for a click event on the item
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Function that returns HTML
   */
  prefix: PropTypes.func
};
